const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct?.dataset.productHandle;
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";
var recentViewedInitialized = false;

var selectors = {
  grid: "[grid-recentViewProduct]",
};

var initializeRecentViewedProducts = function () {
  if (recentViewedInitialized || !recentViewdProduct || !recentViewedProductHandle) return;
  recentViewedInitialized = true;
  updaterecentViewPorduct(recentViewedProductHandle);
  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    recentViewsetupGrid(Recentgrid);
  }
};

document.addEventListener("visitorConsentCollected", function (event) {
  if (event.detail?.preferencesAllowed) {
    initializeRecentViewedProducts();
  } else if (event.detail && event.detail.preferencesAllowed === false) {
    resetrecentViewPorduct();
    recentViewedInitialized = false;
    var Recentgrid = document.querySelector(selectors.grid);
    if (Recentgrid) Recentgrid.innerHTML = "";
    recentViewdProduct?.classList.add("no-js-inline");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (!recentViewdProduct || !recentViewedProductHandle) return;

  var initializeWhenAllowed = function () {
    if (window.Shopify?.customerPrivacy?.preferencesProcessingAllowed()) {
      initializeRecentViewedProducts();
    }
  };

  if (window.Shopify?.customerPrivacy) {
    initializeWhenAllowed();
    return;
  }

  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (error) {
        if (!error) initializeWhenAllowed();
      }
    );
  }
});

var recentViewsetupGrid = function (Recentgrid) {
  var requestsRecentViewed = getrecentViewPorduct()
    .filter(function (handle) {
      return handle && handle !== recentViewedProductHandle;
    })
    .slice(-8)
    .reverse()
    .map(function (handle) {
      var productTileTemplateUrl = "/products/" + encodeURIComponent(handle) + "?view=recent-view-card";
      return fetch(productTileTemplateUrl)
        .then(function (res) {
          return res.ok ? res.text() : "";
        })
        .catch(function () {
          return "";
        });
    });

  Promise.all(requestsRecentViewed).then(function (responses) {
    var successfulResponses = responses.filter(Boolean);
    if (!successfulResponses.length) return;

    var recentViewPorductProductCards = successfulResponses.join("");
    Recentgrid.innerHTML = recentViewPorductProductCards;
    recentViewdProduct.classList.remove("no-js-inline");

    var slider = Recentgrid.closest(".productSlider");
    if (slider?.swiper) {
      slider.swiper.update();
      slider.swiper.slideTo(0, 0);
    }
  });
};

var getrecentViewPorduct = function () {
  try {
    var recentViewPorduct =
      localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || false;
    if (recentViewPorduct)
      return recentViewPorduct.split(LOCAL_STORAGE_DELIMITER);
  } catch (error) {
    return [];
  }
  return [];
};

var setrecentViewPorduct = function (array) {
  var recentViewPorduct = array.join(LOCAL_STORAGE_DELIMITER);
  try {
    if (array.length) {
      localStorage.setItem(
        LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY,
        recentViewPorduct
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY);
    }
  } catch (error) {
    return "";
  }
  return recentViewPorduct;
};

var updaterecentViewPorduct = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  var indexInrecentViewPorduct = recentViewPorduct.indexOf(handle);
  if (indexInrecentViewPorduct === -1) {
    recentViewPorduct.push(handle);
  } else {
    let currentViewdProduct = recentViewPorduct.splice(
      indexInrecentViewPorduct,
      1
    )[0];
    recentViewPorduct.push(currentViewdProduct);
  }
  return setrecentViewPorduct(recentViewPorduct.slice(-20));
};

var recentViewPorductContains = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  return recentViewPorduct.indexOf(handle) !== -1;
};

var resetrecentViewPorduct = function () {
  return setrecentViewPorduct([]);
};
